/**
 * Marinovel 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const marinovelPaymentConfig: BrandPaymentConfig = {
  brand: 'marinovel',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/marinovel/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/marinovel/vip_bg.webp',
      memberSubscribeBg: '/images/marinovel/member_subscribe_bg.webp',
      vipIcon: '/images/marinovel/vip_icon2.png',
      vipDiscountIcon: '/images/marinovel/vip_discount.png',
      discountBg: '/images/marinovel/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(132deg, #1660FB 0%, #4B9CFC 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #7AAEFF 0%, #A8C8FF 70%, #EEF4FF 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #4B9CFC, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FF873F',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#EEF4FF',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #7AAEFF 0%, #A8C8FF 70%, #EEF4FF 100%)',
      pinkGradient: 'linear-gradient(132deg, #1660FB 0%, #4B9CFC 100%)',
      memberSubscribeBg: '/images/marinovel/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
